module.exports = __webpack_public_path__ + "lhi1-0c4d4f68797c347a1f4332fe21abae9c.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/lhi1.png
// module id = rVfS
// module chunks = client